import { makeNullSafeDomainGetter, userNotificationDevicesDomainSelector } from './common';

export const userNotificationDevicesSelector = makeNullSafeDomainGetter(userNotificationDevicesDomainSelector, 'getNotificationDevices');
